import { faCheckCircle, faCircleInfo, faCommentPlus, faPencil, faTimesCircle, faTrashAlt } from '@fortawesome/pro-light-svg-icons'
import { useCallback, useRef, useState } from 'react'
import { displayDate } from '../../../../../../utils/globals/date'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import { displayFormatedNumber } from '../../../../../../utils/globals/numbers'
import { getCurrencySymbol } from '../../../../../../utils/globals/price'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { getPreparePricesConfigParam, getUserPermissions } from '../../../../../../utils/reducers/getters'
import { DisplayPercentGettingParams } from '../../../../../Displays/DisplayPercent'
import DisplayPrice, { DisplayPriceGettingParams, DisplayPriceNotRounded } from '../../../../../Displays/DisplayPrice'
import { CalculateParamsTy } from '../../../../../Displays/DisplayPrice/types'
import TwinIcon, { TwinIconToolTipProps } from '../../../../../TwinIcon'
import { RowData } from '../../../../types'
import { ParameterValueType } from '../../../../VirtualTableListing/Subcomponents/types'
import { ITLayoutTableModalOpen } from '../../types'
import { ITInputPriceStateFull } from '../Inputs'
import { ITInputsOnChangeInputs } from '../Inputs/types'
import { CustomRenderImageToolTip, CustomRenderImageToolTipProps, DeleteRowProps, useDeleteRowLogic } from '../../../../VirtualTableListing/CustomRenders'
import TwinToolTip from '../../../../../TwinToolTip'
import { useMeasureShortsDictionary } from '../../../../../../utils/hooks/useMeasureDictionary'
import { permissionCheck } from '../../../../../PermissionChecker/function'
import { processedTypesInversed } from '@teinor/erp/types/company/order/general'

export interface ITDisplayPriceProps {
    value: number
    with_vat: boolean
    CurrencyId: string
    className?: string
}

export const ITDisplayPrice: React.FC<ITDisplayPriceProps> = ({ className, ...params }) => {
    return (
        <DisplayPriceGettingParams {...params} className={'input_table_displaynumber_r ' + (className || '')} />
    )
}
export interface ITDisplayPriceNotRoundedProps {
    value: number
    with_vat: boolean
    CurrencyId: string
}

export const ITDisplayPriceNotRounded: React.FC<ITDisplayPriceProps> = ({...params }) => {
    return (
        <DisplayPriceNotRounded {...params} />
    )
}

export interface ITDisplayPercentProps {
    value: number
}

export const ITDisplayPercent: React.FC<ITDisplayPercentProps> = ({ ...params }) => {
    return (
        <DisplayPercentGettingParams {...params} className='input_table_displaynumber_r' />
    )
}


export interface ITDisplayFinalPriceProps extends ITDisplayPriceProps {
    allRowData: RowData
    setOpenModal: React.Dispatch<React.SetStateAction<ITLayoutTableModalOpen>>
}

export const ITDisplayFinalPrice: React.FC<ITDisplayFinalPriceProps> = ({ setOpenModal, allRowData, ...params }) => {
    const calculateParams = getPreparePricesConfigParam() as CalculateParamsTy
    return (
        <div className='flex items-center input_price w-full'>
            <DisplayPrice {...params} calculateParams={{...calculateParams, 'roundingPriceType': 'medium'}} className='input_table_displaynumber_r' />
            <TwinIcon icon={faCircleInfo} className='cursor-pointer hover:text-green-43' size='lg' onClick={() => setOpenModal({ type: 'priceProduct', allRowData })} />
        </div>
    )
}

export type ITDisplayInitialPriceProps = ITDisplayInitialPriceLogicProps & {
    value: number
    CurrencyId: string
    dataKey: string
    setOpenModal: React.Dispatch<React.SetStateAction<ITLayoutTableModalOpen>>
}
export const ITDisplayInitialPrice: React.FC<ITDisplayInitialPriceProps> = ({ ...params }) => {
    const haveQuotePermissions = permissionCheck(getUserPermissions('quoteOther.updateQuoteTotalPrice'), 'read')
    return (
        <ITDisplayInitialPriceBase {...params} skipEdit={!haveQuotePermissions} />
    )
}

export type ITDisplayInitialPriceBaseProps = ITDisplayInitialPriceLogicProps & {
    value: number
    CurrencyId: string
    dataKey: string
    setOpenModal: React.Dispatch<React.SetStateAction<ITLayoutTableModalOpen>>
    skipEdit?: boolean
    readOnlyFnc?: (allRowData: RowData) => boolean
}

export const ITDisplayInitialPriceBase: React.FC<ITDisplayInitialPriceBaseProps> = ({ allRowData, dataKey, onChange, setOpenModal, skipEdit, readOnlyFnc, ...params }) => {
    const { t } = useTwinTranslation()
    const { editPrice, handleEditPrice, myOnBlur, ref } = useITDisplayInitialPriceLogic({ onChange, allRowData, ...params })
    const calculateParams = getPreparePricesConfigParam() as CalculateParamsTy
    const readOnly = !allRowData?.OrderId || readOnlyFnc?.(allRowData)
    return (
        <div className='flex items-center input_price w-full' ref={ref} >
            {editPrice ?
                <ITInputPriceStateFull className='edit_unit_price' {...params} initialValue={params.value} dataKey={dataKey} allRowData={allRowData} onBlur={myOnBlur} value={String(params.value)} />
                :
                <DisplayPrice calculateParams={{ ...calculateParams, 'roundingPriceType': 'medium' }} className={'input_table_displaynumber_r ' + (skipEdit ? 'mr-0' : '')} {...params} with_vat={false} />
            }
            {!skipEdit && !readOnly ?
                <ITIconToolTip className='cursor-pointer hover:text-green-43' icon={faPencil} id={'editInitialPrice' + allRowData.id} message={t('editUnitPrice', 'Editar precio unitario')} onClick={handleEditPrice} />
                : null}
        </div>
    )
}

interface ITDisplayInitialPriceLogicProps {
    allRowData: RowData
    onChange: ITInputsOnChangeInputs
    priceField?: string
}

const useITDisplayInitialPriceLogic = ({ onChange, allRowData, priceField = 'initialUnitPriceWithoutTax' }: ITDisplayInitialPriceLogicProps) => {
    const [editPrice, setEditPrice] = useState<boolean>(false)
    const ref = useRef<any>(null)

    const handleEditPrice = useCallback(() => {
        setEditPrice((old) => !old)
        setTimeout(() => {
            const input = ref.current?.querySelector('.edit_unit_price .input_field_input')
            if (input) {
                input.focus()
            }
        }, 40)
    }, [setEditPrice])

    const myOnBlur = useCallback((myValue: string) => {
        if (myValue) {
            onChange(allRowData.absoluteIndex || allRowData.rowIndex, priceField, myValue)
        }
        handleEditPrice()
    }, [onChange, handleEditPrice, allRowData, priceField])
    return { handleEditPrice, editPrice, myOnBlur, ref }
}

export const OrderDisplayInitiaPrice: React.FC<ITDisplayInitialPriceBaseProps> = ({ ...params }) => {
    const readOnlyFnc = (allRowData: any) => {
        return allRowData?.processed === true || (allRowData?.processed !== false && allRowData?.processed !== processedTypesInversed['unprocessed']) ? true : false
    }
    return (
        <ITDisplayInitialPriceBase readOnlyFnc={readOnlyFnc} {...params} />
    )
}

export type ITDisplayEditFinalPriceProps = ITDisplayEditFinalPriceLogicProps & {
    value: number
    with_vat: boolean
    CurrencyId: string
    dataKey: string
    setOpenModal: React.Dispatch<React.SetStateAction<ITLayoutTableModalOpen>>
}

export const ITDisplayEditFinalPrice: React.FC<ITDisplayEditFinalPriceProps> = ({ ...params }) => {
    const haveQuotePermissions = permissionCheck(getUserPermissions('quoteOther.updateQuoteTotalPrice'), 'read')
    return (
        <ITDisplayEditFinalPriceBase {...params} skipEdit={!haveQuotePermissions} />
    )
}

export type ITDisplayEditFinalPriceBaseProps = ITDisplayEditFinalPriceLogicProps & {
    value: number
    with_vat: boolean
    CurrencyId: string
    dataKey: string
    setOpenModal: React.Dispatch<React.SetStateAction<ITLayoutTableModalOpen>>
    skipEdit?: boolean
    readOnlyFnc?: (allRowData: RowData) => boolean
}

export const ITDisplayEditFinalPriceBase: React.FC<ITDisplayEditFinalPriceBaseProps> = ({ allRowData, dataKey, onChange, setOpenModal, with_vat, skipEdit, readOnlyFnc, ...params }) => {
    const { t } = useTwinTranslation()
    const { editPrice, handleEditPrice, myOnBlur, ref } = useITDisplayEditFinalPriceLogic({ onChange, allRowData, with_vat })
    const calculateParams = getPreparePricesConfigParam() as CalculateParamsTy
    const readOnly = !allRowData?.OrderId || readOnlyFnc?.(allRowData)
    return (
        <div className='flex items-center input_price w-full' ref={ref} >
            {editPrice ?
                <ITInputPriceStateFull className='edit_final_price' {...params} initialValue={params.value} dataKey={dataKey} allRowData={allRowData} onBlur={myOnBlur} value={String(params.value)} />
                :
                <DisplayPrice calculateParams={{ ...calculateParams, 'roundingPriceType': 'medium' }} className={'input_table_displaynumber_r ' + (skipEdit ? 'mr-0' : '')} {...params} with_vat={false} />
            }
            {!skipEdit && !readOnly ?
                <ITIconToolTip className='cursor-pointer hover:text-green-43' icon={faPencil} id={'editFinalPrice_' + allRowData.id} message={t('editTotalPrice', 'Editar precio total')} onClick={handleEditPrice} />
            : null}
        </div>
    )
}

interface ITDisplayEditFinalPriceLogicProps {
    allRowData: RowData
    onChange: ITInputsOnChangeInputs
    with_vat?: boolean
}
export type EditFinalPriceValueTy = {
    keyValue: string
    value: string
}
const useITDisplayEditFinalPriceLogic = ({ onChange, allRowData, with_vat }: ITDisplayEditFinalPriceLogicProps) => {
    const [editPrice, setEditPrice] = useState<boolean>(false)
    const ref = useRef<any>(null)

    const handleEditPrice = useCallback(() => {
        setEditPrice((old) => !old)
        setTimeout(() => {
            const input = ref.current?.querySelector('.edit_final_price .input_field_input')
            if (input) {
                input.focus()
            }
        }, 40)
    }, [setEditPrice])

    const myOnBlur = useCallback((myValue: string) => {
        if (myValue) {
            onChange(allRowData.absoluteIndex || allRowData.rowIndex, with_vat ? 'finalPriceToRecalculateWithVat' : 'finalPriceToRecalculate', myValue)
        }
        handleEditPrice()
    }, [onChange, handleEditPrice, allRowData, with_vat])
    return { handleEditPrice, editPrice, myOnBlur, ref }
}

export const OrderDisplayEditFinalPriceBase: React.FC<ITDisplayEditFinalPriceBaseProps> = ({ ...params }) => {
    const readOnlyFnc = (allRowData: any) => {
        return  allRowData?.processed === true || (allRowData?.processed !== false && allRowData?.processed !== processedTypesInversed['unprocessed']) ? true : false
    }
    return (
        <ITDisplayEditFinalPriceBase readOnlyFnc={readOnlyFnc} {...params} />
    )
}

export interface ITTypeQuantityDisplayProps {
    measure: ParameterValueType
    value: string
}

export const ITTypeQuantityDisplay: React.FC<ITTypeQuantityDisplayProps> = ({ value, measure }) => {
    const { t } = useTwinTranslation()
    const { measureItems } = useMeasureShortsDictionary()
    let tag = measure
    if (String(measure) === '0' || !measure) {
        tag = t('u', 'u')
    } else if (measureItems[measure]) {
        tag = measureItems[measure]
    }
    const number = displayFormatedNumber(value)
    return (
        <span>{number} {tag}</span>
    )
}

export interface ITDiscountDisplayProps {
    CurrencyId: string
    value: string
    typeDiscount: number
    decimals?: number
}

export const ITDiscountDisplay: React.FC<ITDiscountDisplayProps> = ({ value, typeDiscount, CurrencyId, decimals }) => {
    const currencySymbol = getCurrencySymbol(CurrencyId)
    const items: TwinDictionary = { 0: '%', 1: currencySymbol, 2: currencySymbol + ' /u' }
    if (!value) {
        return null
    }
    const number = displayFormatedNumber(value, decimals, decimals)
    return (
        <span>{number} {items[typeDiscount]}</span>
    )
}

export interface ITDateDisplayProps {
    value: string
}

export const ITDateDisplay: React.FC<ITDateDisplayProps> = ({ value }) => {
    return (
        <span>{displayDate(new Date(value))}</span>
    )
}
export interface ITDisplayImageProps extends CustomRenderImageToolTipProps {}

export const ITDisplayImage: React.FC<ITDisplayImageProps> = ({ value, allRowData, className }) => {
    const myValue = value || allRowData?.['Product.Product.ProductImages.url']
    return <CustomRenderImageToolTip {...{ value: myValue, allRowData, className }} />
}
export interface ITDateDisplayProps {
    value: string
}

export const ITDisplayNumber: React.FC<ITDateDisplayProps> = ({ value }) => {
    const number = displayFormatedNumber(value)
    return (
        <span>{number}</span>
    )
}

export interface ITDisplayVatProps {
    value?: number
    className?: string
}

export const ITDisplayVat: React.FC<ITDisplayVatProps> = ({ value, className }) => {
    if (!value) {
        return null
    }
    const number = displayFormatedNumber(value)
    return (<span className={className || ''}>{number} %</span>)
}
export interface ITEditableTextProps {
    value?: string
    dataKey: string
    allRowData: RowData
    setOpenModal: React.Dispatch<React.SetStateAction<ITLayoutTableModalOpen>>
    readOnlyFnc?: (allRowData: RowData) => boolean
}

export const ITEditableText: React.FC<ITEditableTextProps> = ({ allRowData, dataKey, setOpenModal, value, readOnlyFnc }) => {
    const { t } = useTwinTranslation()
    const readOnly = readOnlyFnc?.(allRowData) || false
    if (readOnly) {
        return null
    }
    if(!value){
        return <ITIconToolTip className='cursor-pointer hover:text-green-43 mr-10' icon={faCommentPlus} id={'addNotesQuote_' + allRowData.id} message={t('addNotes', 'Añadir notas')} onClick={() => setOpenModal({ type: 'editableText', allRowData: { rowIndex: allRowData?.absoluteIndex, dataKey, value } })} />
    }
    return (
        <div className='flex items-center w-full'>
            <TwinToolTip id={'notesQuote_' + allRowData.id} content={value} className='max-w-300' />
            <span className='twin_elipsis_table_two_lines mr-10' data-tooltip-id={'notesQuote_' + allRowData.id}>{value}</span>
            <ITIconToolTip className='cursor-pointer hover:text-green-43 mr-10' icon={faPencil} id={'editNotesQuote_' + allRowData.id} message={t('editNotes', 'Editar notas')} onClick={() => setOpenModal({ type: 'editableText', allRowData: { rowIndex: allRowData?.absoluteIndex, dataKey, value } })} />
        </div>)
}

export interface ITEditableNameProps {
    value?: string
    dataKey: string
    allRowData: RowData
    setOpenModal: React.Dispatch<React.SetStateAction<ITLayoutTableModalOpen>>
    readOnlyFnc?: (allRowData: RowData) => boolean
}

export const ITEditableName: React.FC<ITEditableNameProps> = ({ allRowData, dataKey, setOpenModal, value, readOnlyFnc }) => {
    const { t } = useTwinTranslation()
    const readOnly = readOnlyFnc?.(allRowData) || false
    if (readOnly) {
        return null
    }
    return (
        <ITIconToolTip className='cursor-pointer hover:text-green-43 mr-10' icon={faPencil} id={'editCopyProductNameEditQuote_' + allRowData?.id} message={t('editName', 'Editar nombre')} onClick={() => setOpenModal({ type: 'editableText', allRowData: { rowIndex: allRowData?.absoluteIndex, dataKey, value } })} />
    )
}

export interface ITBooleanRenderProps {
    value?: string
    widthBoolean?: number
    allRowData: RowData
    dataKey: string
    onChange: ITInputsOnChangeInputs
}

export const ITBooleanRender: React.FC<ITBooleanRenderProps> = ({ allRowData, value, onChange, dataKey, widthBoolean }) => {
    let renderThis: JSX.Element | null = null
    if (String(value) === 'true') {
        renderThis = <TwinIcon icon={faCheckCircle} className='text-green-43' size='lg' />
    } else {
        renderThis = <TwinIcon icon={faTimesCircle} className='text-red-BA' size='lg' />
    }
    return (
        <div className='flex items-center w-full custom_render_boolean cursor-pointer' onClick={() => onChange(allRowData.absoluteIndex || allRowData.rowIndex, dataKey, String(value) === 'true' ? 'false' : 'true')}>
            <div className='text-center' style={{ width: widthBoolean ?? '100%' }}>
                {renderThis}
            </div>
        </div>
    )
}

interface ITIconToolTipProps extends TwinIconToolTipProps {}

export const ITIconToolTip: React.FC<ITIconToolTipProps> = ({ message, id, children, icon, onClick, classNameIcon, className, subRef, positionStrategy, place = 'top'}) => {
    return (
        <div ref={subRef} className={'relative ' + (className || '')}>
            <TwinToolTip id={id} content={message} place={place} positionStrategy={positionStrategy}/>
            <div>
                {children}
                {icon ? <TwinIcon data-tooltip-id={id} className={'cursor-pointer row_icon ' + (classNameIcon || '')} icon={icon} size='lg' onClick={onClick} /> : null}
            </div>
        </div>
    )
}

interface ITDeleteRowProps extends DeleteRowProps { }

export const ITDeleteRow: React.FC<ITDeleteRowProps> = ({ ...params }) => {
    const {t} = useTwinTranslation()
    const {handleDelete} = useDeleteRowLogic({...params})
    if ((params.allRowData.BuyDeliveryNoteId && params.allRowData.BuyInvoiceId)) {
        return null
    }
    return (
        <ITIconToolTip message={t('deleteLine', 'Eliminar línea')} id={'deleteLine'+params.allRowData.id} onClick={handleDelete as any} icon={faTrashAlt}/>
    )
}

export interface ITDeleteRowSellProps extends DeleteRowProps { }

export const ITDeleteRowSell: React.FC<ITDeleteRowSellProps> = ({ ...params }) => {
    const {t} = useTwinTranslation()
    const { handleDelete } = useDeleteRowLogic({ ...params })
    if (params.allRowData.SellDeliveryNoteProductId || params.allRowData.SellInvoiceProductId || (params.allRowData.processed && params.allRowData.processed !== processedTypesInversed['unprocessed']) ) {
        return null
    }
    return (
        <ITIconToolTip message={t('deleteLine', 'Eliminar línea')} id={'deleteLine'+params.allRowData.id} onClick={handleDelete as any} icon={faTrashAlt}/>
    )
}

interface ITDeleteRowBuyProps extends DeleteRowProps { }

export const ITDeleteRowBuy: React.FC<ITDeleteRowBuyProps> = ({ ...params }) => {
    const { t } = useTwinTranslation()
    const { handleDelete } = useDeleteRowLogic({ ...params })
    if (params.allRowData.BuyDeliveryNoteProductId) {
        return null
    }
    return (
        <ITIconToolTip message={t('deleteLine', 'Eliminar línea')} id={'deleteLine' + params.allRowData.id} onClick={handleDelete as any} icon={faTrashAlt} />
    )
}
interface ITDeleteRowManufacturingProps extends DeleteRowProps { }

export const ITDeleteRowManufacturing: React.FC<ITDeleteRowManufacturingProps> = ({ ...params }) => {
    const { t } = useTwinTranslation()
    const { handleDelete } = useDeleteRowLogic({ ...params })
    if (parseInt(String(params.allRowData?.processed)) > processedTypesInversed['unprocessed']) {
        return null
    }
    return (
        <ITIconToolTip message={t('deleteLine', 'Eliminar línea')} id={'deleteLine' + params.allRowData.id} onClick={handleDelete as any} icon={faTrashAlt} />
    )
}